import { of } from 'rxjs/observable/of'
import { fromPromise } from 'rxjs/observable/fromPromise'

import {
  CREATE_CSV_USERS,
} from '../../pages/users/actions'
import {
  setData,
} from '../../common/utils/resource'
import { API_VERSION } from '@app/api'

export default function createCsvUsers(action$, store, { API }) {
  return action$.ofType(CREATE_CSV_USERS).mergeMap(action => {
    return fromPromise(API('users/upload', API_VERSION.TWO).request('POST', undefined, { data: action.data })).switchMap(_ => {
      return fromPromise(API('users/', API_VERSION.TWO).request('GET')).switchMap(res => of(setData(res, { resource: { namespace: 'users', successMessage: { POST: 'Your CSV has been successfully uploaded.' } }, type: 'POST' })))
    })
  })
}
